import { useEffect, useState } from "react";
import { Header, Loading } from "../components";
import {
  Ambiente,
  Contingencia,
  DataBr,
  FormaPagto,
  HoraBr,
  MoedaBr,
  Bandeira,
  Status,
  Rodoviaria,
  Porcento,
} from "../components/Formatar";
import Axios from "axios";

const ConsultaBilhetes = () => {
  const params = new URLSearchParams(window.location.search);

  const [tipo, setTipo] = useState(params.get("tipo") || "bilhete");
  const [valor, setValor] = useState(params.get("valor") || "");
  const [dados, setDados] = useState([]);
  const [toast, setToast] = useState(false);
  const [loading, setLoading] = useState(false);

  const getDados = async () => {
    if (!tipo || !valor) return;

    console.log(params);

    try {
      setLoading(true);

      const response = await Axios.get(
        `http://187.86.158.45:3010/api/bilhetes/${tipo}/${valor}`,
      );

      setDados(response.data || []);
      setToast(true);
    } catch (error) {
      console.error("Erro ao consultar bilhetes:", error);
      setDados([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const params = new URLSearchParams({ tipo, valor });
    window.history.pushState({}, "", `/consultaBilhetes?${params}`);

    await getDados();
  };

  useEffect(() => {
    getDados();
  }, []);

  return (
    <>
      {loading && <Loading />}

      <Header />

      {!loading && (
        <div className="container">
          <div className="d-flex justify-content-center my-4">
            <div className="col-sm-10">
              <form onSubmit={handleSubmit}>
                <h5 className="text-center">Consulta de Bilhetes</h5>

                <div className="row mt-3">
                  <div className="col-sm-8">
                    <input
                      id="valor"
                      type="text"
                      className="form-control"
                      value={valor}
                      onChange={(e) => setValor(e.target.value)}
                      required
                    />
                  </div>

                  <div className="col-sm-2">
                    <select
                      className="form-select"
                      aria-label="Tipo"
                      value={tipo}
                      onChange={(e) => setTipo(e.target.value)}
                    >
                      <option value="bilhete">Bilhete</option>
                      <option value="chave">Chave</option>
                      <option value="autorizacao">Autorização</option>
                      <option value="nsu">NSU</option>
                      <option value="documentoPagto">Pix</option>
                    </select>
                  </div>

                  <div className="col-sm-2">
                    <button type="submit" className="btn btn-primary col-sm-12">
                      Consultar
                    </button>
                  </div>
                </div>
              </form>

              {toast && <Bilhete dados={dados} />}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const InfoItem = ({ label, value }) => (
  <div className="col-lg-2 col-md-3 col-sm-4 col-6 mb-1">
    <div className="text-muted small lh-1">{label}</div>
    <div className="fw-semibold small text-truncate">{value || "-"}</div>
  </div>
);

const Bilhete = (props) => {
  const dados = props.dados;

  return (
    <>
      {dados.map((bpe) => (
        <div className="my-5 px-2 py-3 text-center border small rounded text-capitalize">
          <div className="row mb-2">
            <div className="text-muted small lh-1">Chave</div>
            <div className="fw-semibold small text-truncate">
              <a
                href={`https://dfe-portal.svrs.rs.gov.br/bpe/qrCode?chBPe=${bpe.chave}&tpAmb=1`}
                target="_blank"
                rel="noreferrer"
              >
                {bpe.chave}
              </a>
            </div>
          </div>
          <hr />
          <div className="row mb-2">
            <InfoItem label="Bilhete" value={bpe.bilhete} />
            <InfoItem label="Série" value={bpe.serie} />
            <InfoItem label="Origem" value={bpe.origem} />
            <InfoItem label="Destino" value={bpe.destino} />
            <InfoItem label="Poltrona" value={bpe.poltrona} />
            <InfoItem label="Box" value={bpe.plataforma} />
          </div>
          <div className="row mb-2">
            <InfoItem label="Descrição" value={bpe.descricaoPassagem} />
            <InfoItem label="Linha" value={bpe.linha} />
            <InfoItem label="Passageiro" value={bpe.nomeCliente} />
            <InfoItem label="Documento" value={bpe.docCliente} />
            <InfoItem label="Data Viagem" value={DataBr(bpe.dhViagem)} />
            <InfoItem label="Hora Viagem" value={HoraBr(bpe.dhViagem)} />
          </div>

          <div className="row mb-2">
            <InfoItem label="Emissor" value={Rodoviaria(bpe.serie)} />
            <InfoItem label="Operador" value={Rodoviaria(bpe.operador)} />
            <InfoItem label="Ambiente" value={Ambiente(bpe.ambiente)} />
            <InfoItem label="Contingência" value={Contingencia(bpe.emissao)} />
            <InfoItem label="Data Venda" value={DataBr(bpe.dhVenda)} />
            <InfoItem label="Hora Venda" value={HoraBr(bpe.dhVenda)} />
          </div>

          <hr />

          <div className="row mb-2">
            <InfoItem
              label="Forma"
              value={bpe?.descricaoPagto || FormaPagto(bpe?.formaPagto)}
            />
            <InfoItem label="Documento" value={bpe.documentoPagto} />
            <InfoItem label="Tipo Desconto" value={bpe.tipoDesconto} />
            <InfoItem label="Bandeira" value={Bandeira(bpe.bandeira)} />
            <InfoItem label="Autorização" value={bpe.autorizacao} />
            <InfoItem label="NSU" value={bpe.nsu} />
          </div>

          <div className="row mb-2">
            <InfoItem label="Tarifa" value={MoedaBr(bpe.tarifa)} />
            <InfoItem label="Seguro" value={MoedaBr(bpe.seguro)} />
            <InfoItem label="Taxa" value={MoedaBr(bpe.tmr)} />
            <InfoItem label="SVI" value={MoedaBr(bpe.svi)} />
            <InfoItem label="Desconto" value={MoedaBr(bpe.valorDesconto)} />
            <InfoItem label="Total" value={MoedaBr(bpe.valorLiquido)} />
          </div>

          <div className="row mb-2">
            <InfoItem label="Dinheiro" value={MoedaBr(bpe.valorDinheiro)} />
            <InfoItem label="Crédito" value={MoedaBr(bpe.valorCredito)} />
            <InfoItem label="Débito" value={MoedaBr(bpe.valorDebito)} />
            <InfoItem label="Vale" value={MoedaBr(bpe.valorVale)} />
            <InfoItem label="Pix" value={MoedaBr(bpe.valorPix)} />
            <InfoItem label="Outros" value={MoedaBr(bpe.valorOutros)} />
          </div>

          <hr />
          <div className="row mb-2">
            <InfoItem label="CST" value={bpe.icmsCst} />
            <InfoItem
              label="Redução Base"
              value={Porcento(bpe.icmsReducaoBC)}
            />
            <InfoItem label="Base Cálculo" value={MoedaBr(bpe.icmsBC)} />
            <InfoItem label="Alíquota" value={Porcento(bpe.icmsAliquota)} />
            <InfoItem
              label="Crédito Outorgado"
              value={MoedaBr(bpe.icmsCredito)}
            />
            <InfoItem label="Valor ICMS" value={MoedaBr(bpe.icmsValor)} />
          </div>

          <hr />

          <div className="row mb-2">
            <InfoItem label="Embarcada" value={bpe.dhCheckin ? "Sim" : "Não"} />
            <InfoItem label="Dispositivo" value={bpe.imei} />
            <InfoItem label="Data Aberta" value={DataBr(bpe.dhAberta)} />
            <InfoItem label="Hora Aberta" value={HoraBr(bpe.dhAberta)} />
            <InfoItem label="Data Embarque" value={DataBr(bpe.dhCheckin)} />
            <InfoItem label="Hora Embarque" value={HoraBr(bpe.dhCheckin)} />
          </div>

          <hr />

          <div className="row mb-2">
            <InfoItem
              label="Status"
              value={(bpe.chaveNova && "Remarcado") || Status(bpe.status)}
            />
            <InfoItem
              label="Bpe Original"
              value={
                bpe.chaveAntiga && (
                  <a
                    href={`http://192.168.0.117:3003/consultaBilhetes?tipo=chave&valor=${bpe.chaveAntiga}`}
                  >
                    Abrir
                  </a>
                )
              }
            />
            <InfoItem
              label="BPe Remarcado"
              value={
                bpe.chaveNova && (
                  <a
                    href={`http://192.168.0.117:3003/consultaBilhetes?tipo=chave&valor=${bpe.chaveNova}`}
                  >
                    Abrir
                  </a>
                )
              }
            />
            <InfoItem label="Data Status" value={DataBr(bpe.dhEvento)} />
            <InfoItem label="Hora Status" value={HoraBr(bpe.dhEvento)} />
            <InfoItem label="Protocolo" value={bpe.protocolo} />
          </div>
        </div>
      ))}
    </>
  );
};

export default ConsultaBilhetes;
